import { isAxiosError } from "axios";

export const getErrorMessage = (
  error: unknown
): { message: string; shouldRedirect?: boolean } => {
  if (isAxiosError(error) && error.status === 401) {
    return { message: "You need to log in first", shouldRedirect: true };
  }
  if (isAxiosError(error) && error.status === 404) {
    return {
      message: "The requested resource does not exist or it has expired",
    };
  }

  return { message: "Something went wrong" };
};
